import type { OrderDirection, ComponentSettingsDatasetSortField, ComponentSettingsJctField } from '@report-content';
export function fieldToSortField(
    field: ComponentSettingsJctField,
    direction: OrderDirection,
): ComponentSettingsDatasetSortField {
    return {
        column_name: field.column_name,
        dir: direction,
        reference_name: field.reference_name,
        reference_name_escaped: field.reference_name_escaped,
        value_type: field.value_type,
    };
}
